<template>
  <div class="contact">
    <HeaderComponent/>
    <div class="contact_Box" style="position: relative;">
      <div class="contact_Body">

        <div class="content"  v-if="!s_Type">
          <div class="contact_nav LeftCenter">
            <div class="nav">
              <span :class="index === 0 ? 'active' : ''" @click="index = 0">品牌方</span>
              <span :class="index === 2 ? 'active' : ''" @click="index = 2">合作伙伴</span>
              <span :class="index ===1 ? 'active' : ''" @click="index = 1">应聘者</span>
            </div>

          </div>
          <div class="item1 LeftCenter" v-if="index===1">
            <div class="wid100" style="margin-top: 10%;">
              <img src="https://cyvideo.i-oranges.com/home/12.png" class="wid100" alt="">
              <div style="width: 100%; margin-top: 5%;">
               <a href="https://www.zhipin.com/gongsi/job/5747f33ea2ff4f5303xz09-1.html?ka=search_rcmd_joblist_5747f33ea2ff4f5303xz09-1" target="_blank"  style="display: inline-block; width: 38%;"> <img src="https://cyvideo.i-oranges.com/home/20.png" class="wid100" alt=""></a>
              </div>
            </div>

          </div>

          <div class="wid100" v-if="index !== 1">
            <div v-for="(form, i) in forms" :key="i" v-show="index === i || (index === 2 && i === 1)" class="item2">
              <form>
                <div class="wid100">
                  <div class="wid100">
                    <p>您的姓名：</p>
                    <input type="text" v-model="form.name" class="input-field" required>
                  </div>
                  <div class="wid100" style="margin-top: 60px;">
                    <p>您的电话：</p>
                    <input type="tel" v-model="form.phone" class="input-field" required>
                  </div>
                </div>
                <div class="wid100" style="margin-top: 60px;">
                  <div class="wid100">
                    <p>公司名称：</p>
                    <input type="text" v-model="form.company" class="input-field" required>
                  </div>
                  <div class="wid100" style="margin-top: 60px;">
                    <p>您的职位：</p>
                    <input type="text" v-model="form.job" class="input-field" required>
                  </div>
                </div>
                <div style="margin-top: 60px;">
                  <p>{{ i === 0 ? '业务诉求：' : '合作类型：' }}</p>
                  <input type="text" v-model="form.appeal" class="input-field business-input" required>
                </div>
                <br>

              </form>
            </div>
          </div>
          <div class="checkbox-label" v-if="index !=1" >
            <button type="submit" @click="handleSubmit(index)">提交</button>
          </div>
        </div>

        <div class="success LeftCenter" v-if="s_Type">
          <img src="https://cyvideo.i-oranges.com/home/13.png" alt="">
        </div>

      </div>
    </div>
    <FooterComponent/>
  </div>
</template>

<script>

import HeaderComponent from "../components/HeaderComponent";
import FooterComponent from "../components/FooterComponent";
import AboutComponent from "../components/AboutComponent";
import SwiperComponents from "../components/SwiperComponents";
import ProjectComponent from "../components/ProjectComponent";
import ServiceComponent from "../components/ServiceComponent";
import Index from "./index";
import {getByWork, submit} from "../api/article";

export default {
  name: "contact",
  components: {
    Index,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    SwiperComponents,
    ProjectComponent,
    ServiceComponent,

  },
  data(){
    return{
      index:0,
      s_Type:0,
      forms: [
        { name: "", phone: "", company: "", job: "", appeal: "", type: 0 },
        { name: "", phone: "", company: "", job: "", appeal: "", type: 1 }
      ]
    }

  },
  methods:{
      changeIndex(){
        // this.thi
      },
    async handleSubmit(formIndex) {
      // 修正 formIndex，合作伙伴对应 forms[1]
      const realIndex = formIndex === 2 ? 1 : formIndex;
      const formData = this.forms[realIndex];

      // 简单校验逻辑
      if (!formData || !formData.name || !formData.phone || !formData.company || !formData.job || !formData.appeal) {
        alert("请填写完整信息！");
        return;
      }
      const phonePattern = /^1[3-9]\d{9}$/;
      if (!phonePattern.test(formData.phone)) {
        alert("请输入有效的手机号！");
        return;
      }
      try {
        const response = await submit(formData);
        console.log(response.data);
        this.s_Type = 1;
      } catch (error) {
        console.error("提交失败:", error);
      }
    }

  },
  mounted() {

  }
}
</script>

<style scoped>
.contact_Box {
  width: 100%;
  margin: auto auto 50px auto;

}

.content,.success {
  width: 60%;
 margin:5% auto 0 auto;

  /*background: #fff;*/
  padding: 30px 5%;
}
.success{min-height: 454px;}

.success img{
  width: 95.5%;
}


.contact_nav {
  width: 100%;
  margin-top: 50px;
  white-space: nowrap;
}
.contact_nav .nav {
  width: 50%;

}

.contact_Body {
  width: 100%;
  padding-bottom: 100px;
}

.contact_nav span {
  display: inline-block;
  text-align: center;
  padding: 8px 0;
  color: #fff;
  font-size: 22px;
  letter-spacing: 1px;
  margin-right: 50px;
  font-family: ali_R;
  cursor: pointer;
}

.contact_nav span.active {
  /*background: #ff6600;*/
  /*color: #fff;/*/
  color: #ff6600;
  border-bottom: 2px solid #ff6600;
}

.item1 {
  height: 454px;
}
.item1 img {
 width: 70%;
}

.item2 {
  width:100%;
  margin-top: 138px;
}

.content p {

  color: #b7b7b7;
  font-size: 18px;
  width: 130px;
  white-space: nowrap;
  letter-spacing: 1px;
  font-family: ali_R;
}

.input-field {
  border: none;
  border-bottom: 1px solid #b7b7b7;
  outline: none;
  padding: 1px 0;
  background: none;
  font-size: 20px;
  color: #808080;
  width: 40%;
  font-family:"Microsoft YaHei UI";
  margin-top: 20px;
  transition: width 0.5s;
}
.input-field:hover{
  width: 50%;

}

.business-input:hover{
  width: 100%;
}

.business-input {
  width: 95%;
}

.checkbox {
  width: 20px;
  height: 20px;
  background: #ff6600;
  display: inline-block;
  text-align: center;
  line-height: 20px;
  color: white;
  font-weight: bold;
}
.checkbox-label{width: 100%; text-align: left; margin-top: 120px;}
.checkbox-label button{  font-family: ali_R;width: 120px; padding:3px 0 ; cursor: pointer;background-color:#ff6600; border:none; color: #fff;
font-size: 22px; letter-spacing: 5px; transition: all 0.5s}
.checkbox-label button:hover{transform: scale(1.06); border-radius: 10px;}


</style>



// WEBPACK FOOTER //
// src/view/contact.vue